// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__H2daW","aside":"style_aside__qDCfW","active":"style_active__gEzX2","content":"style_content__TVqxh"};